import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import environment  from './environment';

const root = ReactDOM.createRoot(document.getElementById('root'));

const fetchConfig = async() => {

  try {
    const response = await fetch("/app.properties.json", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const configCache = await response.json();
    environment.VERSION = configCache.VERSION;
    environment.ENV = configCache.ENV;
    environment.NCC_SERVER_BASE_URL = configCache[configCache.ENV].NCC_SERVER_BASE_URL;
    environment.NCC_WEB_BASE_URL = configCache[configCache.ENV].NCC_WEB_BASE_URL;
    environment.NCC_MICRO_UI_BASE_URL = configCache[configCache.ENV].NCC_MICRO_UI_BASE_URL;
    root.render(
      <React.StrictMode>
        <BrowserRouter>
        <App />
        </BrowserRouter>
      </React.StrictMode>
    );
  } catch (error) {
    console.error("Error fetching config:", error);
    throw error;
  }
}


fetchConfig();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
